import React, { Component } from "react";
import { AppCard, createTabHeaderTemplate, PageLayout } from "../../../components/ui";
import { TabPanel, TabView } from "primereact/tabview";
import Vendors from "./Vendors";
import VendorCategories from "./VendorCategories";
import VendorSetting from "./VendorSetting";
import VendorSettingCredentials from "./VendorSettingCredentials";
import { Dialog } from "primereact/dialog";

interface VendorSettingDialogProps {
    isVisible: boolean;
    onHide: () => void;
    editable: boolean;
    vendorId: number;
}

interface VendorSettingDialogState {
    activeTabIndex: number;
}

export default class VendorSettingDialog extends Component<VendorSettingDialogProps, VendorSettingDialogState> {
    constructor(props: VendorSettingDialogProps | Readonly<VendorSettingDialogProps>) {
        super(props);

        this.state = {
            activeTabIndex: 0,
        };
    }

    // async componentDidMount() {
    // }

    render() {
        return (
            <Dialog header="Vendor Settings" visible={this.props.isVisible} style={{ width: "70vw" }} onHide={this.props.onHide}>
                <PageLayout noTitle>
                    <AppCard className="!m-0">
                        <AppCard.Body className="!p-0 m-0">
                            <TabView
                                activeIndex={this.state.activeTabIndex}
                                onTabChange={(e) => {
                                    this.setState({ activeTabIndex: e.index });
                                }}
                                pt={{
                                    nav: {
                                        className: "gap-1",
                                    },
                                }}
                            >
                                <TabPanel pt={{ content: { className: "pt-0 px-5 pb-5" } }} headerTemplate={createTabHeaderTemplate(this.state.activeTabIndex)} header="Services">
                                    <VendorSetting vendorId={this.props.vendorId} />
                                </TabPanel>

                                <TabPanel
                                    pt={{ content: { className: "pt-0 px-5 pb-5" } }}
                                    headerTemplate={createTabHeaderTemplate(this.state.activeTabIndex)}
                                    header="Credentials"
                                >
                                    <VendorSettingCredentials vendorId={this.props.vendorId} editable={this.props.editable} />
                                </TabPanel>
                            </TabView>
                        </AppCard.Body>
                    </AppCard>
                </PageLayout>
            </Dialog>
        );
    }
}
